import React, { FC, Fragment } from 'react';
import { Grid, TableCell, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { find } from 'lodash';

import { Network, SharesItem } from 'api';
import { SocialAccountIcon } from 'components';
import { withSocialConnections, IWithSocialConnections } from 'providers/queries';
import { isUrl } from 'features/content/helpers';
import { getSocialAccountName } from 'helpers';

import UrlMetadata from '../UrlMetadata';
import Body from '../Body';

interface IProps {
  items: SharesItem[];
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles>, IWithSocialConnections {}

const styles = (theme: Theme) =>
  createStyles({
    cell: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    network: {
      display: 'inline-flex',
      marginRight: theme.spacing(2),
    },
    icon: {
      marginRight: theme.spacing(0.5),
    },
    content: {
      marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(withSocialConnections(), withStyles(styles));

const ScheduledShareCell: FC<IPropsEnhanced> = ({ classes, connections, items }) => {
  const content = items[0].content;

  if (!content) {
    return <TableCell align="left" classes={{ body: classes.cell }} />;
  }

  function getSocialAccount(item: SharesItem) {
    const { network_id } = item;
    const account = find(connections, ['id', network_id]);

    return getSocialAccountName(account);
  }

  function renderNetworks() {
    return items.map(item => {
      return (
        <Fragment key={item.id}>
          <Grid item>
            <div className={classes.network}>
              <Grid item>
                <SocialAccountIcon
                  active
                  provider={item.network as Network}
                  size={16}
                  className={classes.icon}
                />
              </Grid>
              <Grid item>
                <Typography>{getSocialAccount(item)}</Typography>
              </Grid>
            </div>
            <Typography variant="body2">{item.user_commentary}</Typography>
          </Grid>
        </Fragment>
      );
    });
  }

  return (
    <TableCell align="left" classes={{ body: classes.cell }}>
      <Grid container direction="column" wrap="nowrap" spacing={2}>
        {renderNetworks()}
      </Grid>
      <div className={classes.content}>
        {isUrl(content) ? <UrlMetadata content={content} /> : <Body content={content} />}
      </div>
    </TableCell>
  );
};

export default enhancers(ScheduledShareCell);
